import { Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import { getEstablishment } from "~v2/http-request/establishment";
import { getOptions } from "~helpers/options";

const EstablishmentFormItem = ({ handleChange = (value) => {} }) => {
  const [options, setOptions] = useState();
  useEffect(() => {
    getEstablishment().then((res) => {
      let options = getOptions({
        data: res.establishments,
        value: "_id",
        label: "name",
      });
      setOptions(options);
    });
  }, []);
  return (
    <Form.Item
      labelAlign="left"
      label={"Establishments"}
      name={"establishment"}
      rules={[
        {
          required: true,
          message: "Please select an establishment!",
        },
      ]}
    >
      <Select
        labelInValue
        onChange={handleChange}
        style={{ width: "100%" }}
        allowClear
        placeholder={"Select establishment..."}
        options={options}
      />
    </Form.Item>
  );
};

export default EstablishmentFormItem;
